export const analyticsConstants = {
  GET_DASHBOARD_STATS_REQUEST: "GET_DASHBOARD_STATS_REQUEST",
  GET_DASHBOARD_STATS_SUCCESS: "GET_DASHBOARD_STATS_SUCCESS",
  GET_DASHBOARD_STATS_FAILURE: "GET_DASHBOARD_STATS_FAILURE",

  GET_EXECUTION_STATS_REQUEST: "GET_EXECUTION_STATS_REQUEST",
  GET_EXECUTION_STATS_SUCCESS: "GET_EXECUTION_STATS_SUCCESS",
  GET_EXECUTION_STATS_FAILURE: "GET_EXECUTION_STATS_FAILURE",

  GET_EXECUTION_TRENDS_REQUEST: "GET_EXECUTION_TRENDS_REQUEST",
  GET_EXECUTION_TRENDS_SUCCESS: "GET_EXECUTION_TRENDS_SUCCESS",
  GET_EXECUTION_TRENDS_FAILURE: "GET_EXECUTION_TRENDS_FAILURE",

  GET_API_USAGE_REQUEST: "GET_API_USAGE_REQUEST",
  GET_API_USAGE_SUCCESS: "GET_API_USAGE_SUCCESS",
  GET_API_USAGE_FAILURE: "GET_API_USAGE_FAILURE",

  GET_API_FAILURES_REQUEST: "GET_API_FAILURES_REQUEST",
  GET_API_FAILURES_SUCCESS: "GET_API_FAILURES_SUCCESS",
  GET_API_FAILURES_FAILURE: "GET_API_FAILURES_FAILURE",

  GET_API_RECORDS_REQUEST: "GET_API_RECORDS_REQUEST",
  GET_API_RECORDS_SUCCESS: "GET_API_RECORDS_SUCCESS",
  GET_API_RECORDS_FAILURE: "GET_API_RECORDS_FAILURE",

  GET_RUNBOOK_OVERVIEW_REQUEST: "GET_RUNBOOK_OVERVIEW_REQUEST",
  GET_RUNBOOK_OVERVIEW_SUCCESS: "GET_RUNBOOK_OVERVIEW_SUCCESS",
  GET_RUNBOOK_OVERVIEW_FAILURE: "GET_RUNBOOK_OVERVIEW_FAILURE",

  GET_RUNBOOK_EXECUTIONS_REQUEST: "GET_RUNBOOK_EXECUTIONS_REQUEST",
  GET_RUNBOOK_EXECUTIONS_SUCCESS: "GET_RUNBOOK_EXECUTIONS_SUCCESS",
  GET_RUNBOOK_EXECUTIONS_FAILURE: "GET_RUNBOOK_EXECUTIONS_FAILURE",

  GET_EXECUTION_DETAIL_REQUEST: "GET_EXECUTION_DETAIL_REQUEST",
  GET_EXECUTION_DETAIL_SUCCESS: "GET_EXECUTION_DETAIL_SUCCESS",
  GET_EXECUTION_DETAIL_FAILURE: "GET_EXECUTION_DETAIL_FAILURE",
};
